export const liveConfig = {
    type: 'tn',
    loading: {
        width: "15px",
        marginBottom: "5px"
    },
    background: "#fff",
    hlBG: "#F3F3F3",
    random: {
        background: "#85CCC7", borderRadius: "50%",
        padding: "0 2px",
        border: "1px solid #85CCC7",
        letterSpacing: 0,
        lineHeight: 1,
    },
    row: {
        row_0: {
            normal: {
                fontSize: "45px",
                color: "#930001",
                fontFamily: "Arial Black ,sans-serif",
                lineHeight: 1,
            }, loading: {
                width: "20px"
            }, random: {
                fontSize: "45px",
                color: "#930001",
                fontFamily: "Arial Black ,sans-serif",
                lineHeight: 1.3,
                borderRadius: "50%",
                border: "1px solid #a4ffbb",
                letterSpacing: 0,
                padding: "0 2px",

            }
        }, row_8: {
            normal: {
                fontSize: "34px",
                color: "#930001",
                fontWeight: "900",
                fontFamily: "Arial Black ,sans-serif",
                lineHeight: 1.17
            }, loading: {
                width: "20px"
            }, random: {
                fontSize: "34px",
                color: "#930001",
                lineHeight: 1.5,
                fontWeight: "900",
                fontFamily: "Arial Black ,sans-serif",
                borderRadius: "50%",
                border: "1px solid #a4ffbb",
                letterSpacing: 0,
                padding: "0 2px",

            }
        }
    },
    hlIndex: [1, 3, 5],
    ng: {
        loading: {
            width: "20px"
        },
        hlIndex: [1, 3, 5, 7],
        row: {
            row_0: {
                normal: {
                    fontSize: "60px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    lineHeight: 1.4
                }, loading: {
                    width: "28px",
                }, random: {
                    fontSize: "60px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    lineHeight: 1.4,
                    borderRadius: "50%",
                    border: "1px solid #a4ffbb",
                    letterSpacing: 0,
                    padding: "0 2px",
                }
            },
            row_1: {
                normal: {
                    fontSize: "45px",
                    fontWeight: "900",
                    lineHeight: 1.17
                },
                loading: {
                    width: "22px"
                },
                random: {
                    fontSize: "45px",
                    fontWeight: "900",
                    lineHeight: 1.4,
                    borderRadius: "50%",
                    border: "1px solid #a4ffbb",
                    letterSpacing: 0,
                    padding: "0 2px",
                }
            },
            row_6: {
                normal: {
                    color: "#110FFF",
                    fontSize: "50px",
                    fontWeight: "900",
                    lineHeight: 1.17
                },
                loading: {
                    width: "23px",
                    marginTop: "10px"
                },
                random: {
                    color: "#110FFF",
                    fontSize: "50px",
                    fontWeight: "900",
                    paddingLeft: "1px",
                    lineHeight: 1.4,
                    borderRadius: "50%",
                    border: "1px solid #a4ffbb",
                    letterSpacing: 0,
                    padding: "0 2px",
                }
            },
            row_7: {
                normal: {
                    fontSize: "50px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    lineHeight: 1.4
                }, loading: {
                    width: "25px",
                    marginTop: "18px"
                }, random: {
                    fontSize: "50px",
                    color: "#930001",
                    fontWeight: "900",
                    fontFamily: "Arial Black ,sans-serif",
                    borderRadius: "50%",
                    border: "1px solid #a4ffbb",
                    letterSpacing: 0,
                    padding: "0 2px",
                    lineHeight: 1.4
                }
            }
        },
    }
};